import script from "./ImageTexture.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageTexture.vue?vue&type=script&setup=true&lang=js"

import "./ImageTexture.vue?vue&type=style&index=0&id=35f981a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f981a0"]])

export default __exports__